import { setTerm } from './helpers';

export const setIsFromOffrep = setTerm('from_offrep');
